// import moment from 'moment'

const state = {
  id: 0,
  url: '',
  description: '',
  title: '',
  grade: [],
  interest: 'ALL',
  mapel: '',
  thumbnail:'',
  source: '',
  duration: ''
}

const mutations = {
  video_reset: function(state) {
    state.id = 0
    state.url = ''
    state.description = ''
    state.title = ''
    state.grade = []
    state.interest = 'ALL'
    state.mapel = ''
    state.thumnail = ''
    state.source = ''
    state.duration = ''
  },
  video_init: function(state, payload) {
    state.id = payload.id
    state.url = payload.url
    state.description = payload.description
    state.title = payload.title
    state.grade = payload.grade
    state.interest = payload.interest
    state.mapel = payload.mapel
    state.thumbnail = payload.thumbnail
    state.source = payload.source
    state.duration = payload.duration
  },
  video_set_id: function(state, payload) {
    state.id = payload
  },
  video_set_url: function(state, payload) {
    state.url = payload
  },
  video_set_description: function(state, payload) {
    state.description = payload
  },
  video_set_title: function (state, payload) {
    state.title = payload
  },
  video_set_grade: function (state, payload) {
    state.grade = payload
  },
  video_set_interest: function (state, payload) {
    state.interest = payload
  },
  video_set_mapel: function(state, payload) {
    state.mapel = payload
  },
  video_set_thumbnail: function(state, payload) {
    state.thumbnail = payload
  },
  video_set_source: function(state, payload) {
    state.source = payload
  },
  video_set_duration: function(state, payload) {
    state.duration = payload
  }
}

const getters = {
//   openedAt: function(state) {
//     var time = 0
//     state.tryouts.forEach(function(tryout) {
//       var tryoutStartTime = moment(tryout.start_date + ' ' + tryout.start_time, 'YYYY-MM-DD HH:mm').format('x')
//       if (time == 0 || tryoutStartTime < time) time = Number(tryoutStartTime)
//     })

//     return time
//   },
//   closedAt: function(state) {
//     var time = 0
//     state.tryouts.forEach(function(tryout) {
//       var tryoutEndTime = moment(tryout.end_date + ' ' + tryout.end_time, 'YYYY-MM-DD HH:mm').format('x')
//       if (time == 0 || tryoutEndTime > time) time = Number(tryoutEndTime)
//     })

//     return time
//   }
}

export default {state, mutations, getters}



// WEBPACK FOOTER //
// ./src/store/modules/video.js